import React, { FC } from 'react'

import { Routes } from 'common/constants'
import { InterSvgIcon } from 'components'

import IcHouse from '@interco/icons/core/action-navigation/ic_house'

import { IconPlaceholder } from '../styles'
import { THeaderRightIconProps } from '../types'

export const HeaderRightIcon: FC<THeaderRightIconProps> = ({ goTo, showHomeIcon, rightIcon }) => {
  if (showHomeIcon)
    return (
      <IcHouse
        onClick={() => goTo(Routes.ROOT)}
        color="var(--secondary500)"
        width={24}
        height={24}
      />
    )

  if (rightIcon)
    return (
      <InterSvgIcon
        iconRef={rightIcon.iconRef}
        color={rightIcon.color}
        width={rightIcon.size}
        height={rightIcon.size}
        onClick={rightIcon.onClick}
      />
    )

  return <IconPlaceholder />
}
